// Conversão pura: (dias, dataReferenciaIso) -> string DD/MM/AAAA.
// dataReferenciaIso é uma string no formato "YYYY-MM-DD" (output do <input type="date">).
// Retorna null se qualquer entrada for inválida.
export function formatDataDeDias(dias, dataReferenciaIso) {
    if (!dataReferenciaIso) return null;
    if (dias === null || dias === undefined || isNaN(Number(dias))) return null;

    const [y, m, d] = dataReferenciaIso.split('-').map(Number);
    if (!y || !m || !d) return null;

    // Construir em UTC para evitar deslocamento por timezone local.
    const base = Date.UTC(y, m - 1, d);
    const ms = base + Math.round(Number(dias)) * 86400000;
    const dt = new Date(ms);

    const dd = String(dt.getUTCDate()).padStart(2, '0');
    const mm = String(dt.getUTCMonth() + 1).padStart(2, '0');
    const yyyy = dt.getUTCFullYear();
    return `${dd}/${mm}/${yyyy}`;
}

// Inverso: data ISO "YYYY-MM-DD" -> número de dias desde dataReferenciaIso.
// Retorna null se inválido.
export function diasEntreDatas(dataAlvoIso, dataReferenciaIso) {
    if (!dataAlvoIso || !dataReferenciaIso) return null;
    const [ay, am, ad] = dataAlvoIso.split('-').map(Number);
    const [ry, rm, rd] = dataReferenciaIso.split('-').map(Number);
    if (!ay || !am || !ad || !ry || !rm || !rd) return null;
    const alvo = Date.UTC(ay, am - 1, ad);
    const ref = Date.UTC(ry, rm - 1, rd);
    return Math.round((alvo - ref) / 86400000);
}
